<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
const [name] = createNamespace('TicketCenterResettleStandardDisplay')

export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtProj.ResettleStandardData>>,
      default: () => ({})
    }
  },
  setup(props) {
    return () => (
      <>
        <div class='ant-row-form-item mb-12'>
          安置总价款：
          <b>{props.data.fangPiaoAnZhiChengQu2} 元/人</b>
        </div>
        <div class='ant-row-form-item'>
          房票安置人员过渡费标准：
          <b>{props.data.fangPiaoAnZhiChengQu} 元/人</b>
        </div>
      </>
    )
  }
})
</script>
